import React from 'react';
import { cx } from './cx';

/** Text wordmark (no logo asset exists yet). Swap the <span> mark for an <img> when a logo is supplied. */
export const Wordmark = ({ className, light }: { className?: string; light?: boolean }) => (
  <span className={cx('flex items-center gap-2.5 text-lg font-extrabold tracking-tight', light ? 'text-white' : 'text-ink', className)}>
    <span className="grid h-7 w-7 place-items-center rounded-lg bg-brand-600 text-[15px] font-extrabold text-white" aria-hidden="true">R</span>
    Responsily
  </span>
);
